@if ($validationState | async; as validationState) {
  <div class="tracking-domain">
    <h4 class="title">Tracking domain</h4>
    @if (validationState === 'failed') {
      <div class="info-container red">
        <svg class="icon">
          <use xlink:href="#red-sign-with-minus"></use>
        </svg>
        <div class="message">
          Address not recognized. It means the DNS hasn't updated to include your domain's new
          settings yet. This may take up to 72 hours. Please give it hour and try again later
        </div>
      </div>
    }
    @if (validationState === 'ok') {
      <div class="info-container green">
        <svg class="icon">
          <use xlink:href="#green-sign-with-check"></use>
        </svg>
        <div class="message">Validation ok.</div>
      </div>
    }
    <div class="domain-input">
      <input
        type="text"
        placeholder="http://track.yourdomain.com"
        [formControl]="domainTrackingNameControl" />
      <button
        class="btn"
        (click)="verifyDomain()"
        [disabled]="
          domainTrackingNameControl.invalid ||
          !domainTrackingNameControl.value ||
          validationState !== 'idle'
        ">
        Verify
      </button>
    </div>
    @if (domainTrackingNameControl.touched && domainTrackingNameControl.invalid) {
      <div class="validation-message">The custom tracking domain format is invalid</div>
    }
  </div>
}
